import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import axios from "axios";


export const googleLoginThunk = createAsyncThunk("auth/googleLogin",
  async (email, { rejectWithValue }) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL; 
      const response = await axios.post(`${API_URL}/google-login`, { email });
      // console.log("Google Login Response:", response);
      if (response.data.success) {
        const expiryTime = new Date().getTime() + 12 * 60 * 60 * 1000;
        localStorage.setItem("authToken", response.data.data.accessToken);
        localStorage.setItem("authUser", JSON.stringify(response.data.data));
        localStorage.setItem("authExpiry", expiryTime);
        localStorage.setItem("authVersion", Date.now());
        return response.data.data;
      } else {
        toast.error(response.data.message || "Login failed");
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);

// 

// https://toon-stacker.tdtrg.com/apis/api/google-login
